module.exports = __webpack_public_path__ + "media/staff/eric-5069a0e8.png";